//This file is used as a middleware to map cometdservice file having functions and React app component to recieve notifications from cometd events
import React from "react";

class CometDMiddleWare extends React.Component {
  name = "CometDMiddleWare";
  constructor(props) {
    console.log("CometDMiddleWare is getting called");
    super(props);
    document.addEventListener(
      "updateComponent",
      this.handleUpdateComponent,
      false
    );
    // console.log("COMETD-LOG-CHECK: 2.1 in constructor");
    
  }

  addEventExplicitly(data) {
     
    // console.log("COMETD-LOG-CHECK: 2.1 in addEventExplicitly");
    if (data) {
      document.addEventListener(
        "updateComponent",
        this.handleUpdateComponent,
        false
      );
    }
  }
  removePreviousEvent(data) {
    // console.log("COMETD-LOG-CHECK: 2.1 in removePreviousEvent");
    if (data) {
      document.removeEventListener(
        "updateComponent",
        this.handleUpdateComponent,
        false
      );
    }
  }
  componentWillUnmount() {
    // console.log("COMETD-LOG-CHECK: 2.1 in componentWillUnmount");
    document.removeEventListener(
      "updateComponent",
      this.handleUpdateComponent,
      false
    );
  }

  componentDidUpdate( ) {
    // console.log("componentDidUpdate in MW", prevProps, this.props);
    // console.log("COMETD-LOG-CHECK: 2.1 in componentDidUpdate");
    this.addEventExplicitly(true)
  }


  handleUpdateComponent = (event) => {
    // console.log("COMETD-LOG-CHECK: 2.1 in handleUpdateComponent");
    if (
      event.detail &&
      event.detail.componentsToUpdate &&
      event.detail.componentsToUpdate.indexOf(this.name) >= 0
    ) {
      this.updateComponent(event.detail.data || {});
    }
  };

  updateComponent = (data) => {
    // console.log("COMETD-LOG-CHECK: PASSED IN MIDDLEWARE " + data);
    // console.log("COMETD-LOG-CHECK: 2.1 in updateComponent");
  };
}

export default CometDMiddleWare;
